import { Row } from "antd";
import Title from "antd/lib/typography/Title";
import React from "react";
import { styled } from "styled-components";
import { useSocialServiceContext } from "../Context";
import { format, parseISO } from "date-fns";

const HistoryContainer = styled(Row)`
  .fullWidth {
    width: 100%;
  }
`;
const ProgramName = styled.p`
  color: #000;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  margin-bottom: 0px;
`;

const AgencyAcronym = styled.span`
  color: #293392;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
`;

const SocialServiceDate = styled.span`
  color: #000;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
`;

const SocialServiecProposedAmount = styled.span`
  color: #000;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

const ProgramDetail = styled.div`
  display: flex; /* Use flexbox for layout */
  align-items: center; /* Vertically center the child elements */
  flex-wrap: wrap; /* Allow the items to wrap as needed */
`;
const StyledTitle = styled(Title)`
  @media only screen and (min-width: 700px) {
    color: white !important;
  }
`;

const HistoryItem = ({
  created_at,
  id,
  program,
  proposed_amount,
}) => {
  const renderProposedAmount = () => {
    switch (program.id) {
      case 1: {
        return "Attendance";
      }
      default: {
        return "No Proposed Amount";
      }
    }
  };

  return (
    <HistoryContainer className="fullWidth" key={id}>
      <ProgramName className="fullWidth">{program.name}</ProgramName>
      <ProgramDetail>
        <AgencyAcronym>{program.agency.name}</AgencyAcronym>-
        <SocialServiceDate>{format(parseISO(created_at), "MMMM d, yyyy h:mma")}</SocialServiceDate>
      </ProgramDetail>
      <SocialServiecProposedAmount className="fullWidth">{renderProposedAmount()}</SocialServiecProposedAmount>
    </HistoryContainer>
  );
};

const History = () => {
  const { history: histories } = useSocialServiceContext();

  return (
    <>
      <Row>
        <StyledTitle level={3}>Social Service History</StyledTitle>
      </Row>
      {histories?.map(item => (
        <HistoryItem key={item.citizen_program_id} {...item} />
      ))}
    </>
  );
};

export default History;
